<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_223_1141)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.24551 13C4.24551 17.5588 7.94118 21.2545 12.5 21.2545C17.0588 21.2545 20.7545 17.5588 20.7545 13C20.7545 8.44118 17.0588 4.74551 12.5 4.74551C7.94118 4.74551 4.24551 8.44118 4.24551 13ZM12.5 2.99551C6.97468 2.99551 2.49551 7.47468 2.49551 13C2.49551 18.5253 6.97468 23.0045 12.5 23.0045C18.0253 23.0045 22.5045 18.5253 22.5045 13C22.5045 7.47468 18.0253 2.99551 12.5 2.99551ZM7.65436 13C7.65436 15.6762 9.82383 17.8456 12.5 17.8456C15.1762 17.8456 17.3456 15.6762 17.3456 13C17.3456 10.3238 15.1762 8.15436 12.5 8.15436C9.82383 8.15436 7.65436 10.3238 7.65436 13ZM12.5 6.40436C8.85733 6.40436 5.90436 9.35733 5.90436 13C5.90436 16.6427 8.85733 19.5956 12.5 19.5956C16.1427 19.5956 19.0956 16.6427 19.0956 13C19.0956 9.35733 16.1427 6.40436 12.5 6.40436ZM13.4706 10.96C13.4706 10.4767 13.0789 10.085 12.5956 10.085C12.1124 10.085 11.7206 10.4767 11.7206 10.96V13.0804V13.4862L12.0304 13.7483L14.3376 15.7008C14.7065 16.013 15.2586 15.967 15.5708 15.5981C15.8829 15.2292 15.837 14.6771 15.4681 14.3649L13.4706 12.6746V10.96Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_223_1141">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
